/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createSlice } from '@reduxjs/toolkit';

import { NameSpace } from '@/constant/store';

import { AppProcess } from '@/types/app-process';
import { BookingObject } from '@/types/person';

const initialState: AppProcess = {
	expandedRowKeys: [],
	homepage: '',
	navigated: false,
	favorites: [],
	isTimePickerShown: false,
	isBookingLoad: false,
	activeBookings: [],
};

export const appProcess = createSlice({
	name: NameSpace.process,
	initialState,
	reducers: {
		setExpandedRowKeys: (state, { payload }) => {
			state.expandedRowKeys = payload;
		},
		setClosedAll: (state) => {
			state.expandedRowKeys = [];
		},
		setHomepage: (state, { payload }) => {
			state.homepage = payload;
		},
		setNavigated: (state, { payload }) => {
			state.navigated = payload;
		},
		setFavorites: (state, { payload }) => {
			state.favorites = payload;
		},
		showTimePicker: (state, { payload }) => {
			state.isTimePickerShown = payload;
		},
		setIsBookingLoad: (state, { payload }) => {
			state.isBookingLoad = payload;
		},
		deleteFavorite: (state, { payload }: { payload: BookingObject }) => {
			state.favorites = state.favorites.filter((favorite) => favorite.id !== payload?.id);
		},
		setActiveBookings: (state, { payload }) => {
			state.activeBookings = payload;
		},
	},
});

export const {
	setExpandedRowKeys,
	setClosedAll,
	setHomepage,
	setNavigated,
	setFavorites,
	deleteFavorite,
	showTimePicker,
	setIsBookingLoad,
	setActiveBookings,
} = appProcess.actions;
